import React from 'react';
import { connect } from 'react-redux';

import LoadingSection from 'components/LoadingSection';
import Modal from 'modals/Modal';
import { setError } from 'store/main/ducks/error';
import { hideModal } from 'store/main/ducks/modal';

type OwnProps = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: Record<string, any>;
  pastDelay: boolean;
};
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setError: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hideModal: (...args: Array<any>) => any;
};

class LoadingModal extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.error && !prevProps.error) {
      // Show the error page if loading the modal bundle failed
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.setError(this.props.error, false);
    }
  }

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.pastDelay) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        <Modal onClose={this.props.hideModal}>
          <LoadingSection delay={0} />
        </Modal>
      );
    }

    return null;
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
export default connect<Props, OwnProps, _, _, _, _>(null, {
  hideModal,
  setError,
})(LoadingModal);
